// extracted by mini-css-extract-plugin
module.exports = {"title":"ChannelsSection_title__aC9be"};